// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-legend {
  background-color: var(--planeed-color-white);
  border-radius: 10px;
  padding: 20px;
  position: absolute;
  min-width: 360px;
}

.legend-space-top {
  padding-top: 35px;
}

.legend-headline {
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 5;
  font-size: 20px;
  font-weight: 500;
}

.legend-content {
  display: flex;
  align-items: center;
  margin: 12px 0;
}
.legend-content img {
  width: 20px;
  margin-right: 10px;
}
.legend-content .text {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.legend-sheet-content {
  padding: 0 12px;
}

.legend-headline ion-button ion-icon {
  color: var(--planeed-blue);
  width: 24px;
  height: 24px;
}

.legend-tutorial {
  margin-top: 30px;
}

.legend-device-headline {
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 2px;
}

.legend-device-content {
  font-size: 16px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
